<template>
  <div id="ManifestQueryDialog">
    <v-dialog v-model="isOpen" persistent max-width="600">
      <v-card>
        <v-card-title class="headline justify-left">
          <h1>{{ title }}</h1>
        </v-card-title>
        <div class="mt-3"></div>
        <v-row class="form-dialog justify-space-between ma-0 px-4">
          <v-col cols="12" md="6" class="px-2">
            <v-menu
              ref="menuDateStart"
              v-model="menuDateStart"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="formattedDateInitial"
                  :disabled="isConfirmBtnLoading"
                  label="Data Inicial da Consulta"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dateInitial"
                :max="getMaxDateForInitial()"
                :active-picker.sync="activePicker"
                locale="pt-br"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="6" class="px-2">
            <v-menu
              ref="menuDateEnd"
              v-model="menuDateEnd"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="formattedDateEnd"
                  :disabled="isConfirmBtnLoading"
                  label="Data Final da Consulta"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dateEnd"
                :min="getMinDateForEnd()"
                :max="getTodayDate()"
                locale="pt-br"
                :active-picker.sync="activePicker"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-card-actions class="d-flex justify-space-between pb-5 justify-center">
          <v-btn
            @click="$emit('update:isOpen'), $emit('cancelClick')"
            large
            color="error"
            class="btn-width"
          >
            Cancelar
          </v-btn>

          <v-tooltip bottom :disabled="isFormValid">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <v-btn
                  :loading="isConfirmBtnLoading"
                  :disabled="!isFormValid"
                  color="success"
                  large
                  class="btn-width"
                  @click="confirmClick()"
                >
                  Confirmar
                </v-btn>
              </div>
            </template>
            <span>Preencha o intervalo de datas corretamente</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    isOpen: {
      default: false,
      type: Boolean
    },
    title: {
      default: 'Você deseja confirmar essa ação?',
      type: String
    },
    confirmButtonText: {
      default: 'Confirmar',
      type: String
    },
    confirmText: {
      default: 'Confirmar',
      type: String
    },
    bodyText: {
      default: null,
      type: String
    },
    isConfirmBtnLoading: {
      default: false,
      type: Boolean
    }
  },

  data: () => ({
    menuDateStart: false,
    menuDateEnd: false,
    dateInitial: null,
    dateEnd: null,
    activePicker: null
  }),
  computed: {
    formattedDateInitial() {
      if (!this.dateInitial) return '';
      const [year, month, day] = this.dateInitial.split('-');
      return `${day}/${month}/${year}`;
    },
    formattedDateEnd() {
      if (!this.dateEnd) return '';
      const [year, month, day] = this.dateEnd.split('-');
      return `${day}/${month}/${year}`;
    },
    isFormValid() {
      return this.dateInitial !== null && this.dateEnd !== null;
    }
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        this.dateInitial = this.getYesterdayDate();
        this.dateEnd = this.getTodayDate();
      }
    }
  },
  methods: {
    getTodayDate() {
      const today = new Date();
      return this.formatDate(today);
    },
    getYesterdayDate() {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      return this.formatDate(yesterday);
    },
    getMaxDateForInitial() {
      if (this.dateEnd) {
        const dateEnd = new Date(this.dateEnd);
        dateEnd.setDate(dateEnd.getDate() + 1);
        return this.formatDate(dateEnd);
      } else {
        const today = new Date();
        return this.formatDate(today);
      }
    },
    getMinDateForEnd() {
      if (this.dateInitial) {
        const dateInitial = new Date(this.dateInitial);
        dateInitial.setDate(dateInitial.getDate() + 1);
        return this.formatDate(dateInitial);
      } else {
        return null;
      }
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    confirmClick() {
      if (this.isFormValid) {
        const data = {
          dateInitial: this.dateInitial,
          dateEnd: this.dateEnd
        };
        this.$emit('confirmClick', data);
      }
    }
  }
};
</script>

<style scoped>
.mt-3 {
  margin-top: 1rem;
}
.form-dialog {
  width: auto;
}
.align-center {
  display: flex;
  align-items: center;
}
.btn-width {
  width: 280px;
}
</style>
